import { Component,Input,Output,EventEmitter } from '@angular/core';
import {WsService} from '../../utils/network/ws.service';
import {SessionManagerService} from '../services/session/session-manager.service';
@Component({
 selector: "dskl-wb-teacher",
  templateUrl: 'teacher-wb.component.html'
}) 
export class TeacherWbComponent { 
  @Input() board;
  @Output() onGroupSelected = new EventEmitter();
  constructor(private sessionManager: SessionManagerService) { }
 
onBackToGroups(e){
  console.log(" back to groups")
 
}
  groupId=null;
  pageName="Всички групи"
}



// WEBPACK FOOTER //
// /app/src/app/wb/teacher/teacher-wb.component.ts